import { Table } from "@/features/Table";
import {
  type F1IssuersExclusion,
  f1_issuers_exclusion_columns,
} from "./columns";
import {
  type FilterF1IssuersExclusionSchema,
  FilterF1IssuersExclusion,
} from "./filter";
import { useLocation } from "react-router";

const client = "f1-quantilia";
const table_name = "f1_issuers_exclusion";

export const F1IssuersExclusionTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<F1IssuersExclusion, typeof FilterF1IssuersExclusionSchema>
      label="F1 Issuers Exclusion"
      client={client}
      table_name={table_name}
      columns={f1_issuers_exclusion_columns}
      filter={<FilterF1IssuersExclusion />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
